import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { Row, Col, Card } from 'react-bootstrap';

type VariantTileProps = {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  variant?: 'primary' | 'warning'
};
function VariantTile( {
  title, subtitle, variant = 'primary',
}: VariantTileProps ) {
  return (
    <Col xs={6}>
      <Card
        className={classNames( 'h-100 text--gray17', {
          'card--primary': variant === 'primary',
          'card--warning': variant === 'warning',
        } )}
        body
      >
        <Row>
          <Col>
            <h2 className="title">{title}</h2>
            <p className="subtitle m-0">{subtitle}</p>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}

export default VariantTile;
